/**
 * gift-product.js
 * ギフトセット商品ページ専用スクリプト
 *
 * 依存関係: window.giftPage / window.GIFT_PRODUCT
 *           window.GIFT_BATHBOMB_VARIANTS / window.GIFT_BALM_VARIANTS
 *           window.GIFT_VAPE_VARIANT_ID
 *           window.GIFT_VAPE_STOCK（CBD5%在庫JSON）
 *
 * UI フロー:
 *   STEP1: セット選択（6種）
 *   STEP2: バスボム香り選択（カウンター）
 *   STEP3: バーム香り選択（ラジオ）
 *   STEP4: ベイプフレーバー選択（カウンター・vape含むセットのみ）
 *   STEP5: 金額確認・カートに追加
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     定数
  ------------------------------------------------------------------ */
  var SCENT_BATHBOMB = ['yuzu', 'lavender', 'cedar'];
  var SCENT_BATHBOMB_LABELS = {
    yuzu: 'ゆず',
    lavender: 'ラベンダー',
    cedar: 'シダーウッド'
  };

  var SCENT_BALM = ['warm', 'normal', 'menthol'];
  var SCENT_BALM_LABELS = {
    warm: 'WARM',
    normal: 'NORMAL',
    menthol: 'MENTHOL'
  };

  var FLAVORS = [
    'caramel', 'mix_berry', 'grape', 'strong_menthol', 'muscat',
    'lychee', 'mango', 'strawberry', 'green_apple', 'bear_mint'
  ];

  var FLAVOR_LABEL_MAP = {
    caramel: 'キャラメル',
    mix_berry: 'ミックスベリー',
    grape: 'グレープ',
    strong_menthol: 'ストロングメンソール',
    muscat: 'マスカット',
    lychee: 'ライチ',
    mango: 'マンゴー',
    strawberry: 'ストロベリー',
    green_apple: 'グリーンアップル',
    bear_mint: 'ベアミント'
  };

  /* ベイプCBD5%在庫データ */
  var VAPE_STOCK = window.GIFT_VAPE_STOCK || {};

  /* ------------------------------------------------------------------
     状態管理
  ------------------------------------------------------------------ */
  var state = {
    selectedVariant: null,
    bathbombCounts: { yuzu: 0, lavender: 0, cedar: 0 },
    balmScent: null,
    flavorCounts: {
      caramel: 0, mix_berry: 0, grape: 0, strong_menthol: 0, muscat: 0,
      lychee: 0, mango: 0, strawberry: 0, green_apple: 0, bear_mint: 0
    }
  };

  /* ------------------------------------------------------------------
     ヘルパー
  ------------------------------------------------------------------ */
  function formatPrice(yen) {
    return '<span class="price-currency">¥</span>' + yen.toLocaleString('ja-JP');
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function sumCounts(obj) {
    var total = 0;
    for (var k in obj) {
      if (obj.hasOwnProperty(k)) total += (obj[k] || 0);
    }
    return total;
  }

  function resetBathbombCounts() {
    state.bathbombCounts = { yuzu: 0, lavender: 0, cedar: 0 };
  }

  function resetFlavorCounts() {
    state.flavorCounts = {
      caramel: 0, mix_berry: 0, grape: 0, strong_menthol: 0, muscat: 0,
      lychee: 0, mango: 0, strawberry: 0, green_apple: 0, bear_mint: 0
    };
  }

  function getContents() {
    if (!state.selectedVariant || !state.selectedVariant.contents) {
      return { bathbomb: 0, balm: 0, vape: 0 };
    }
    var c = state.selectedVariant.contents;
    return {
      bathbomb: parseInt(c.bathbomb, 10) || 0,
      balm: parseInt(c.balm, 10) || 0,
      vape: parseInt(c.vape, 10) || 0
    };
  }

  function showEl(el) { if (el) el.style.display = ''; }
  function hideEl(el) { if (el) el.style.display = 'none'; }

  /* ------------------------------------------------------------------
     STEP 1: セット選択
  ------------------------------------------------------------------ */
  function initSetSelection() {
    var grid = document.getElementById('giftSetGrid');
    if (!grid) return;

    var variants = (window.GIFT_PRODUCT && window.GIFT_PRODUCT.variants) || [];

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.gift-set-card');
      if (!card) return;

      var idx = parseInt(card.dataset.setIndex, 10);
      var variant = variants[idx];
      if (!variant) return;

      state.selectedVariant = variant;

      // UIの選択状態
      grid.querySelectorAll('.gift-set-card').forEach(function (c) {
        c.classList.toggle('is-active', c === card);
      });

      // 選択をリセット
      resetBathbombCounts();
      state.balmScent = null;
      resetFlavorCounts();

      // バームのラジオUIリセット
      var balmGroup = document.getElementById('giftBalmGroup');
      if (balmGroup) {
        balmGroup.querySelectorAll('.gift-radio-card').forEach(function (c) {
          c.classList.remove('is-active');
          var input = c.querySelector('input');
          if (input) input.checked = false;
        });
      }

      var contents = getContents();

      // STEP2・STEP3 を表示
      showEl(document.getElementById('giftStep2'));
      showEl(document.getElementById('giftStep3'));

      // STEP4: ベイプあり → 表示、なし → 非表示
      if (contents.vape > 0) {
        showEl(document.getElementById('giftStep4'));
      } else {
        hideEl(document.getElementById('giftStep4'));
      }

      renderBathbombGrid();
      renderVapeGrid();
      renderPrice();
      updateCartButton();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2: バスボム香りカウンター
  ------------------------------------------------------------------ */
  function initBathbombGrid() {
    var grid = document.getElementById('giftBathbombGrid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.gift-scent-minus, .gift-scent-plus');
      if (!btn || btn.disabled) return;

      var key = btn.dataset.scentKey;
      var delta = btn.classList.contains('gift-scent-plus') ? 1 : -1;
      var count = state.bathbombCounts[key] || 0;
      var contents = getContents();

      if (delta === 1) {
        if (sumCounts(state.bathbombCounts) >= contents.bathbomb) return;
        state.bathbombCounts[key] = count + 1;
      } else {
        if (count <= 0) return;
        state.bathbombCounts[key] = count - 1;
      }

      renderBathbombGrid();
      updateCartButton();
    });
  }

  function renderBathbombGrid() {
    var contents = getContents();
    var limit = contents.bathbomb;
    var total = sumCounts(state.bathbombCounts);
    var limitReached = total >= limit;

    // カウンター表示
    var selEl = document.getElementById('giftBathbombSelected');
    var totEl = document.getElementById('giftBathbombTotal');
    if (selEl) selEl.textContent = total;
    if (totEl) totEl.textContent = limit;

    SCENT_BATHBOMB.forEach(function (key) {
      var count = state.bathbombCounts[key] || 0;
      var card = document.querySelector('#giftBathbombGrid .gift-scent-card[data-scent="' + key + '"]');
      var countEl = document.getElementById('giftBathbombCount' + capitalize(key));
      if (!card) return;

      var minusBtn = card.querySelector('.gift-scent-minus');
      var plusBtn = card.querySelector('.gift-scent-plus');

      if (countEl) countEl.textContent = count;
      card.classList.toggle('is-selected', count > 0);
      card.classList.toggle('is-disabled', limitReached && count === 0);
      if (minusBtn) minusBtn.disabled = count <= 0;
      if (plusBtn) plusBtn.disabled = limitReached;
    });

    // 残り選択数メッセージ
    var remainingEl = document.getElementById('giftBathbombRemaining');
    if (remainingEl) {
      var remaining = limit - total;
      if (remaining > 0) {
        remainingEl.textContent = 'あと' + remaining + '個選択できます';
        remainingEl.style.display = '';
      } else {
        remainingEl.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 3: バーム香り選択（ラジオ）
  ------------------------------------------------------------------ */
  function initBalmSelection() {
    var group = document.getElementById('giftBalmGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var card = e.target.closest('.gift-radio-card');
      if (!card) return;

      var val = card.dataset.value;
      state.balmScent = val;

      group.querySelectorAll('.gift-radio-card').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === val);
        var input = c.querySelector('input');
        if (input) input.checked = (c.dataset.value === val);
      });

      updateCartButton();
    });
  }

  /* ------------------------------------------------------------------
     STEP 4: ベイプフレーバーカウンター
  ------------------------------------------------------------------ */
  function initVapeGrid() {
    var grid = document.getElementById('giftVapeGrid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.gift-flavor-minus, .gift-flavor-plus');
      if (!btn || btn.disabled) return;

      var key = btn.dataset.flavorKey;
      var delta = btn.classList.contains('gift-flavor-plus') ? 1 : -1;
      var count = state.flavorCounts[key] || 0;
      var contents = getContents();

      if (delta === 1) {
        var stock = VAPE_STOCK[key];
        if (typeof stock === 'number' && stock <= 0) return;
        if (sumCounts(state.flavorCounts) >= contents.vape) return;
        state.flavorCounts[key] = count + 1;
      } else {
        if (count <= 0) return;
        state.flavorCounts[key] = count - 1;
      }

      renderVapeGrid();
      updateCartButton();
    });
  }

  function renderVapeGrid() {
    var contents = getContents();
    var limit = contents.vape;
    var total = sumCounts(state.flavorCounts);
    var limitReached = total >= limit;

    // カウンター表示
    var selEl = document.getElementById('giftVapeSelected');
    var totEl = document.getElementById('giftVapeTotal');
    if (selEl) selEl.textContent = total;
    if (totEl) totEl.textContent = limit;

    FLAVORS.forEach(function (key) {
      var count = state.flavorCounts[key] || 0;
      var card = document.querySelector('#giftVapeGrid .gift-flavor-card[data-flavor="' + key + '"]');
      var idSuffix = key.charAt(0).toUpperCase() + key.slice(1);
      var countEl = document.getElementById('giftVapeCount' + idSuffix);
      if (!card) return;

      var minusBtn = card.querySelector('.gift-flavor-minus');
      var plusBtn = card.querySelector('.gift-flavor-plus');
      var stockEl = card.querySelector('.product-flavor-stock');

      /* 在庫チェック（CBD5%固定） */
      var stock = VAPE_STOCK[key];
      var inStock = typeof stock === 'number' && stock > 0;

      /* 在庫バッジ表示 */
      if (stockEl) {
        if (inStock) {
          stockEl.className = 'product-flavor-stock in-stock';
          stockEl.textContent = '在庫あり';
        } else {
          stockEl.className = 'product-flavor-stock out-of-stock';
          stockEl.textContent = '在庫なし';
        }
      }

      if (countEl) countEl.textContent = count;

      /* カード状態制御 */
      card.classList.remove('is-selected', 'is-disabled', 'is-soldout');
      if (!inStock) {
        card.classList.add('is-soldout');
      } else if (count > 0) {
        card.classList.add('is-selected');
      } else if (limitReached) {
        card.classList.add('is-disabled');
      }

      if (minusBtn) minusBtn.disabled = count <= 0;
      if (plusBtn) plusBtn.disabled = !inStock || limitReached;
    });

    // 残り選択数メッセージ
    var remainingEl = document.getElementById('giftVapeRemaining');
    if (remainingEl) {
      var remaining = limit - total;
      if (remaining > 0) {
        remainingEl.textContent = 'あと' + remaining + '本選択できます';
        remainingEl.style.display = '';
      } else {
        remainingEl.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 5: 金額表示
  ------------------------------------------------------------------ */
  function renderPrice() {
    var elTotal = document.getElementById('giftPriceTotal');
    if (!elTotal) return;

    if (!state.selectedVariant) {
      elTotal.textContent = '―';
      return;
    }

    elTotal.innerHTML = formatPrice(state.selectedVariant.price);
  }

  /* ------------------------------------------------------------------
     カートボタン制御
  ------------------------------------------------------------------ */
  function updateCartButton() {
    var btn = document.getElementById('giftAddToCartBtn');
    var note = document.getElementById('giftCartNote');
    if (!btn) return;

    var variantSelected = state.selectedVariant !== null;

    var contents = getContents();

    var bathbombTotal = sumCounts(state.bathbombCounts);
    var bathbombDone = bathbombTotal === contents.bathbomb;

    var balmDone = state.balmScent !== null;

    var vapeLimit = contents.vape;
    var flavorTotal = sumCounts(state.flavorCounts);
    var vapeDone = vapeLimit === 0 || flavorTotal === vapeLimit;

    var allDone = variantSelected && bathbombDone && balmDone && vapeDone;

    btn.disabled = !allDone;

    if (note) {
      if (!variantSelected) {
        note.textContent = 'セットを選択してください';
      } else if (!bathbombDone) {
        note.textContent = 'バスボムの香りをあと' + (contents.bathbomb - bathbombTotal) + '個選択してください';
      } else if (!balmDone) {
        note.textContent = 'バームの香りを選択してください';
      } else if (!vapeDone) {
        note.textContent = 'ベイプのフレーバーをあと' + (vapeLimit - flavorTotal) + '本選択してください';
      } else {
        note.textContent = '';
      }
    }
  }

  /* ------------------------------------------------------------------
     カートに追加
  ------------------------------------------------------------------ */
  function initAddToCart() {
    var btn = document.getElementById('giftAddToCartBtn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.disabled || !state.selectedVariant) return;

      var btnText = btn.querySelector('.gift-btn-text');
      var btnLoad = btn.querySelector('.gift-btn-loading');

      btn.disabled = true;
      if (btnText) btnText.style.display = 'none';
      if (btnLoad) btnLoad.style.display = '';

      // properties構築
      var properties = {};

      // バスボム香り
      SCENT_BATHBOMB.forEach(function (key) {
        var count = state.bathbombCounts[key] || 0;
        if (count > 0) {
          properties[SCENT_BATHBOMB_LABELS[key]] = count + '個';
        }
      });

      // バーム香り
      if (state.balmScent) {
        properties['バーム'] = SCENT_BALM_LABELS[state.balmScent];
      }

      // ベイプフレーバー
      FLAVORS.forEach(function (key) {
        var count = state.flavorCounts[key] || 0;
        if (count > 0) {
          properties[FLAVOR_LABEL_MAP[key]] = count + '本';
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: state.selectedVariant.id,
          quantity: 1,
          properties: properties
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          alert('エラーが発生しました。もう一度お試しください。');
          btn.disabled = false;
          if (btnText) btnText.style.display = '';
          if (btnLoad) btnLoad.style.display = 'none';
          updateCartButton();
        });
    });
  }

  /* ------------------------------------------------------------------
     URLパラメータによるセット自動選択
  ------------------------------------------------------------------ */
  var SET_PARAM_MAP = {
    'bb3-bm-vp4': 51533666910424,
    'bb2-bm-vp2': 51533666877656,
    'bb-bm-vp':   51533666844888,
    'bb3-bm':     51533666812120,
    'bb2-bm':     51533666779352,
    'bb-bm':      51533666746584
  };

  function autoSelectFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var setParam = params.get('set');
    if (!setParam || !SET_PARAM_MAP[setParam]) return;

    var targetId = SET_PARAM_MAP[setParam];
    var card = document.querySelector('.gift-set-card[data-variant-id="' + targetId + '"]');
    if (card) {
      card.click();
    }
  }

  /* ------------------------------------------------------------------
     初期化
  ------------------------------------------------------------------ */
  function init() {
    if (!window.giftPage) return;

    // STEP2〜4を非表示でスタート
    hideEl(document.getElementById('giftStep2'));
    hideEl(document.getElementById('giftStep3'));
    hideEl(document.getElementById('giftStep4'));

    initSetSelection();
    initBathbombGrid();
    initBalmSelection();
    initVapeGrid();
    initAddToCart();

    renderBathbombGrid();
    renderVapeGrid();
    renderPrice();
    updateCartButton();

    // URLパラメータによるセット自動選択
    autoSelectFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
